// extracted by mini-css-extract-plugin
export var menuIcon = "_qn-0";
export var menuIconInline = "_qn-1";